import { h } from 'preact';
import SVGWrapper from '../../SvgWrapper';

function PauseIcon({ height = 60, width = 60, color = 'white' }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M12 1.79999C17.6334 1.79999 22.2 6.36668 22.2 12C22.2 17.6333 17.6334 22.2 12 22.2C6.36674 22.2 1.80005 17.6333 1.80005 12C1.80005 6.36668 6.36674 1.79999 12 1.79999ZM9.15005 7.79999C9.06721 7.79999 9.00005 7.86714 9.00005 7.94999V16.05C9.00005 16.1328 9.06721 16.2 9.15005 16.2H10.65C10.7329 16.2 10.8 16.1328 10.8 16.05V7.94999C10.8 7.86714 10.7329 7.79999 10.65 7.79999H9.15005ZM13.35 7.79999C13.2672 7.79999 13.2 7.86714 13.2 7.94999V16.05C13.2 16.1328 13.2672 16.2 13.35 16.2H14.85C14.9329 16.2 15 16.1328 15 16.05V7.94999C15 7.86714 14.9329 7.79999 14.85 7.79999H13.35Z" fill={color} />
    </SVGWrapper>

  );
}

export default PauseIcon;
